import React, { useState, useRef } from 'react';

import Login from './page/login/Login';
import Menu from './page/menu/Menu';
import AddPage from './page/categories-add/AddPage';
import EditPage from './page/categories-edit/EditPage';
import SubcategoryEdit from './page/subcategories-edit/SubcategoryEdit';
import SubcategoryAdd from './page/subcategories-add/SubcategoryAdd';
import RecommendPage from './page/recommendations/RecommendPage';
import RecommendAddPage from './page/recommendations-add/RecommendAddPage';
import MapPage from './page/map-page/MapPage';
import RecommendationsEdit from './page/recommendations-edit/RecommendationsEdit';

function App() {
    // Login, Menu, AddPage, EditPage
    const [currentPage, setCurrentPage] = useState('Login');

    // выбранная категория для редактирования
    const [selectedCategory, setSelectedCategory] = useState(null);

    // выбранная подкатегория для редактирования
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);

    // создание рекомендации
    const [newRecommAddress, setNewRecommAddress] = useState(null);
    const [newRecommCoords, setNewRecommCoords] = useState(null);
    const [nameRu, setNameRu] = useState('');
    const [nameEn, setNameEn] = useState('');
    const [descriptionRu, setDescriptionRu] = useState('');
    const [descriptionEn, setDescriptionEn] = useState('');
    const [image, setImage] = useState(null);
    const [userList, setUserList] = useState('');
    const [userValue, setUserValue] = useState([]);
    const [userId, setUserId] = useState('');
    const [categories, setCategories] = useState([]);
    const [selectSubCategory, setSelectSubCategory] = useState(null);
    const [activeCategoryList, setActiveCategoryList] = useState(false);
    const [responseSubCategory, setResponseSubCategory] = useState(null);
    const [endDate, setEndDate] = useState(new Date());
    const dateTimeRef = useRef(null);

    // редактируемая рекомендация
    const [selectedRecommendation, setSelectedRecommendation] = useState(null);

    return (
        <div className='App'>
            {currentPage === 'Login' && (
                <Login setCurrentPage={setCurrentPage} />
            )}
            {currentPage === 'Menu' && (
                <Menu
                    setCurrentPage={setCurrentPage}
                    setSelectedCategory={setSelectedCategory}
                    setSelectedSubCategory={setSelectedSubCategory}
                />
            )}
            {currentPage === 'AddPage' && (
                <AddPage setCurrentPage={setCurrentPage} />
            )}
            {currentPage === 'EditPage' && (
                <EditPage
                    setCurrentPage={setCurrentPage}
                    selectedCategory={selectedCategory}
                />
            )}
            {currentPage === 'EditSubCategoryPage' && (
                <SubcategoryEdit
                    setCurrentPage={setCurrentPage}
                    selectedSubCategory={selectedSubCategory}
                />
            )}
            {currentPage === 'AddSubCategoryPage' && (
                <SubcategoryAdd
                    setCurrentPage={setCurrentPage}
                    selectedCategory={selectedCategory}
                />
            )}
            {currentPage === 'Recommendations' && (
                <RecommendPage
                    setCurrentPage={setCurrentPage}
                    setSelectedRecommendation={setSelectedRecommendation}
                />
            )}
            {currentPage === 'RecommendationsAdd' && (
                <RecommendAddPage
                    setCurrentPage={setCurrentPage}
                    newRecommAddress={newRecommAddress}
                    newRecommCoords={newRecommCoords}
                    setNewRecommAddress={setNewRecommAddress}
                    setNewRecommCoords={setNewRecommCoords}
                    nameRu={nameRu}
                    nameEn={nameEn}
                    descriptionRu={descriptionRu}
                    descriptionEn={descriptionEn}
                    image={image}
                    userList={userList}
                    userValue={userValue}
                    userId={userId}
                    categories={categories}
                    selectSubCategory={selectSubCategory}
                    activeCategoryList={activeCategoryList}
                    responseSubCategory={responseSubCategory}
                    endDate={endDate}
                    setNameRu={setNameRu}
                    setNameEn={setNameEn}
                    setDescriptionRu={setDescriptionRu}
                    setDescriptionEn={setDescriptionEn}
                    setImage={setImage}
                    setUserList={setUserList}
                    setUserValue={setUserValue}
                    setUserId={setUserId}
                    setCategories={setCategories}
                    setSelectSubCategory={setSelectSubCategory}
                    setActiveCategoryList={setActiveCategoryList}
                    setResponseSubCategory={setResponseSubCategory}
                    setEndDate={setEndDate}
                    dateTimeRef={dateTimeRef}
                />
            )}
            {currentPage === 'MapPage' && (
                <MapPage
                    setCurrentPage={setCurrentPage}
                    setNewRecommAddress={setNewRecommAddress}
                    setNewRecommCoords={setNewRecommCoords}
                />
            )}

            {currentPage === 'RecommendationsEdit' && (
                <RecommendationsEdit
                    setCurrentPage={setCurrentPage}
                    selectedRecommendation={selectedRecommendation}
                />
            )}
        </div>
    );
}

export default App;
